import { CredentialsType } from "../../interfaces/credentials/Credentials";
export const CRED_OPTIONS = [
  { value: CredentialsType.BASIC_AUTH, label: "Basic Authentication" },
  { value: CredentialsType.TOKEN, label: "Bearer Token" },
  { value: CredentialsType.OAUTH2, label: "OAuth2" },
  { value: CredentialsType.JWT, label: "JWT" },
  { value: CredentialsType.CUSTOM_HEADER, label: "Custom Header(s)" },
  { value: CredentialsType.AWS_SIGNATURE, label: "AWS Signature" },

];
export const ATLASSIAN_AUTH_TOKEN = "ATLASSIAN_AUTH_TOKEN";
